import MailIcon from '@mui/icons-material/Mail';
import Button from '@mui/material/Button';
import TranslationText from '@Components/Utilities/TranslationText';

const QuoteMessageAlert = (props) => {

    return (
        <div className={'user-message-alert'}>
            <div className={'user-message-alert__dropdowns'}>
                <div className='message-alert-message-count'>
                    <span><TranslationText tKey='sandhills.messages'/> ({props.MessagesCount})</span>
                </div>
                {props.MessagePreviews && props.MessagePreviews.length > 0 && props.MessagePreviews.map((message) =>
                {
                    return (
                        <div className='message-alert-messages'>
                            <div className='message-alert-message-icon'>
                                <MailIcon color='white'/>
                            </div>
                            <div key={message.EquipmentMessageID} className='message-alert-message'>
                                <a role='button' href={message.Url}>
                                    <div className='sender'><span>{message.Sender}</span></div>
                                    <div className='default-message'>
                                        <span><TranslationText tKey='sandhills.sentyoua' /> </span>
                                        {message.Type == 1 ?
                                            <span><TranslationText tKey='sandhills.tradepubwebsite.mvc.message' /></span> :
                                            <span><TranslationText tKey='sandhills.crm.dscrm.quote' /></span>}
                                    </div>
                                </a>
                            </div>
                        </div>
                    )
                })}
                <div className='message-alert__button'>
                    <Button href={props.MessageUrl} sx={{width: '100%'} }>
                        <TranslationText tKey='sandhills.tradepubwebsite.mvc.viewall' />
                    </Button>
                </div>
            </div>
        </div>
    )
}; 

export default QuoteMessageAlert;